import {capitaliseFirst} from "./applicant/__strings";

export function getSectionAnswer(section, question) {
    if (!question){
        console.log(section)
        console.log(new Error().stack);
    }

    const model = getModel(section, question.model);
    return model[question.name]
}

export function getModel(section, modelName, mortgage) {
    if (mortgage){
        if (section.applicant) {
            // an applicant model or applicant self
            const appIndex = 'applicant' + section.applicant
            if (modelName === 'applicant') {
                return mortgage[appIndex]
            }
            if (section?.index){
                // a repeater section

                return mortgage[appIndex][modelName].find(model => {
                    return model.id === section.index
                })
            }
            return mortgage[appIndex][modelName]
        }
        if (modelName === 'mortgage') {
            return mortgage
        }
        return mortgage[modelName]
    }
    if (section.applicant) {
        // an applicant model or applicant self
        const appIndex = 'applicant' + section.applicant
        if (modelName === 'applicant') {
            return section.props.mortgage[appIndex]
        }
        if (section?.index){
            return section.props.mortgage[appIndex][modelName].find(model => {
                return model.id === section.index
            })
        }
        return section.props.mortgage[appIndex][modelName]
    }
    if (modelName === 'mortgage') {
        return section.props.mortgage
    }
    return section.props.mortgage[modelName]
}
export function getRepeaterModels(section, modelName) {
    if (section.applicant) {
        // an applicant model or applicant self
        const appIndex = 'applicant' + section.applicant
        return section.props.mortgage[appIndex][modelName]
    }
    return []
}

export function evalQuestionText(section, question) {
    if (typeof question.text == "function") {

    }
    if (typeof question.text == "object") {
        const targets = Object.keys(question.text)
        for (let i = 0; i < targets.length; i++) {
            const targetQuestion = section.questions.find(item => targets[i] === item.name)
            const value = getSectionAnswer(section, targetQuestion)
            if (question.text[targets[i]].hasOwnProperty(value)) {
                return question.text[targets[i]][value]
            }
        }
    }
    return false
}
export function isSectionQuestionHidden(section, question) {
    if (question?.hides) {
        const targets = Object.keys(question.hides)
        for (let i = 0; i < targets.length; i++) {
            const targetQuestion = section.questions.find(item => targets[i] === item.name)
            const value = getSectionAnswer(section, targetQuestion)
            const hidden = question.hides[targets[i]](value)
            if (hidden) {
                return true
            }
        }
    }
    return false
}
export function wordLimit(string) {
    const parts = string.split(/[ ]+/);
    parts.length = Math.min(parts.length, 3);
    return parts.join(' ').replace(/,\s*$/, "");
}
export function instanceTitle(section, instance) {
    let title = instance[section.dynamicLabel]
    if (title) {
        switch (section.root) {
            case 'assets':
                switch (instance['savingType']) {
                    case 'SAVING' :
                        title += ' deposit'
                        break
                    case 'INVESTMENT' :
                        title += ' investment'
                        break
                    default:
                }
                break;
            case 'debts':
                switch (instance['debtType']) {
                    case 'CREDITCARD':
                        title += '  Credit Card'
                        break
                    case 'STORECARD':
                        title += ' Store Card'
                        break;
                    case 'LOAN':
                        title += ' Loan'
                        break;
                    case 'OVERDRAFT':
                        title += ' Overdraft'
                    default:
                }
                break;
            default:
                title = wordLimit(title)
        }
    } else {
        title = 'New ' + section.defaultLabel.toLowerCase()
    }
    return title
}
export function instancePersonalisedTitle(section, instance) {
    let title = instance[section.dynamicLabel]
    if (title) {
        switch (section.root) {
            case 'assets':
                switch (instance['assetType']) {
                    case 'SAVING' :
                        title += ' deposit'
                        break
                    case 'INVESTMENT' :
                        title += ' investment'
                        break
                    default:
                }
                break;
            case 'debts':
                switch (instance['debtType']) {
                    case 'CREDITCARD':
                        title += '  Credit Card'
                        break
                    case 'STORECARD':
                        title += ' Store Card'
                        break;
                    case 'LOAN':
                        title += ' Loan'
                        break;
                    case 'OVERDRAFT':
                        title += ' Overdraft'
                    default:
                }
                break;
            default:
                title = wordLimit(title)
        }
    } else {
        title = 'New ' + section.defaultLabel.toLowerCase()
    }

    if (section.applicant) {
        if (section.root === 'properties') {
            return title + ' details';
        }
        if (section.applicant === 1) {
            return 'Your ' + title + ' details'
        }
        if (section.applicant === 2) {
            const other = section.props.mortgage.applicant2?.firstName ? section.props.mortgage.applicant2.firstName : 'The other applicant'
            return other + "'s " + title + ' details'
        }
    }
    return title
}
export function filterHiddenQuestions(section) {
    if (!section){
        return false
    }
    return section.questions.filter(question => {
        return !isSectionQuestionHidden(section, question)
    })
}
export function calcDone(section) {
    const visibleQuestions = filterHiddenQuestions(section)
    if (visibleQuestions){
        const answered = visibleQuestions.filter(question => {
            const ans = getSectionAnswer(section, question)
            return ![undefined, '', null].includes(ans)
        })
        return Math.round((answered.length / visibleQuestions.length) * 100)
    }

}
export function nextEmptyIndex(section) {
    const visibleQuestions = filterHiddenQuestions(section)
    return visibleQuestions.findIndex(item => [undefined, null, ''].includes(getSectionAnswer(section, item)))
}
export function sectionNow(section) {
    if (section?.defaultLabel) {
        let now = 0
        const models = getRepeaterModels(section, section.models[0])
        if (!models.length) {
            const financialKey = `has${capitaliseFirst(section.root)}`
            const appKey = `applicant${section.applicant}`
            const bool = section.props.mortgage[appKey].financial[financialKey]
            if (bool===false){
                return 100
            }
            return 0
        }
        models.forEach(instance => {
            const newSec = {...section}
            newSec.index = instance.id
            const done = calcDone(newSec)
            now = now + done
        })
        if (!now) return 0

        return Math.round(now / models.length)
    }
    return calcDone(section)

    // if (section.applicant) {
    //     const applicantKey = 'applicant' + section.applicant
    //     if (section?.defaultLabel) {
    //         let now = 0
    //         section.props.mortgage[applicantKey][section.root].forEach(instance=>{
    //             const newSec = {...section}
    //             newSec.index = instance.id
    //             const done = calcDone(newSec)
    //             now = now + done
    //         })
    //         // section.instances[section.models[0]].forEach(instance => {
    //         //     const newSec = {...section}
    //         //     newSec.index = instance.id
    //         //     const done = calcDone(newSec)
    //         //
    //         //     now = now + done
    //         // })
    //         if (!now) return 0
    //         return Math.round(now / section.props.mortgage[applicantKey][section.root].length)
    //     }
    // }
    // return calcDone(section)
}
export function getSectionInstance (section,modelName){
    if (section.applicant){
        if (modelName === 'applicant'){
            return section.props.mortgage['applicant'+section.applicant]
        }
        return section.props.mortgage['applicant'+section.applicant][modelName]
    }
    if (modelName==='mortgage'){
        return section.props.mortgage
    }
    return section.props.mortgage[modelName]
}
export function getSectionInstances(section) {
    const instances = {}
    if (!section){
        return false
    }
    for (const model of section.models) {
        instances[model] = getSectionInstance(section,model)
    }
    return instances
}